import { ContextualComments } from './ContextualComments';

interface CIMessagingProps {
  companyId: string;
  configItemId: string;
  configItemName: string;
  currentUser: any;
  accessToken: string;
}

/**
 * @deprecated Use ContextualComments directly.
 * This wrapper exists to maintain backward compatibility during migration.
 */
export function CIMessaging({
  companyId,
  configItemId,
  configItemName,
  currentUser,
  accessToken
}: CIMessagingProps) {
  return (
    <ContextualComments
      companyId={companyId}
      contextType="config_item"
      contextId={configItemId}
      currentUser={currentUser}
      accessToken={accessToken}
      title={`Discussion for ${configItemName}`}
    />
  );
}
